import { Gauge } from "lucide-react";
import { LEVEL_INFO } from "@/lib/api";

export function LevelBadge({ level, testId, dark }) {
  const info = LEVEL_INFO[level] || LEVEL_INFO.facile;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-bold uppercase tracking-wide ${info.cls} ${dark ? "border-transparent" : ""}`}
    >
      <Gauge className="w-3.5 h-3.5" />
      {info.label}
    </span>
  );
}
